import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "distributor_details"
};
const _hoisted_2 = {
  class: "base_details_content"
};
const _hoisted_3 = {
  class: "content"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "基本信息", -1);

const _hoisted_5 = {
  class: "base_details_content_second"
};
const _hoisted_6 = {
  class: "base_details_title_button"
};

const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "tb_title"
}, "分销记录", -1);

const _hoisted_8 = {
  class: "base_details_content_second"
};
import { ref, reactive } from "vue";
import BackTitleView from "@com/BackTitleView.vue";
import StatusBar from "@com/StatusBar.vue";
import DataCollectTable from "@com/table/DataCollectTable.vue";
import { OP_KEY, OPERATIONS, operationsHander } from "@com/table/tableOperations";
import $ from "@util/base";
import useRoute from "@util/router";
import api from "@api/member";
export default {
  __name: 'DistributorDetails',

  setup(__props) {
    const config = {
      type: "distributordetails"
    };
    const route = useRoute();
    route.watchRouter("distributordetails", () => {
      getData();
    });
    const statusList = reactive([{
      label: "全部",
      value: "all",
      total: 0
    }, {
      label: "进行中",
      value: 1,
      total: 0
    }, {
      label: "已完成",
      value: 2,
      total: 0
    }]);
    const data = ref([]);
    const total = ref(0); // function operations(data) {
    //   if (data.mainBusiType !== "1017004") {
    //     return [OPERATIONS.check];
    //   }
    // }

    const tableConfig = {
      showIndex: true,
      // operations: {
      //   label: "操作",
      //   width: 80,
      //   operations: operations,
      // },
      operations: null,
      column: [{
        label: "产品名称",
        prop: "productName",
        width: 120
      }, {
        label: "订单编号",
        prop: "orderCode",
        width: 120
      }, {
        label: "订单类型",
        prop: "orderType",
        width: 100
      }, {
        label: "综合活动码编号",
        prop: "exchangeItemCode",
        width: 120
      }, {
        label: "下单时间",
        prop: "orderCreateTime",
        width: 100
      }, {
        label: "订单状态",
        prop: "orderStatus",
        width: 100
      }, {
        label: "商品数量",
        prop: "sellNum",
        width: 90
      }, {
        label: "归属基地",
        prop: "shopName"
      }, {
        label: "分销员",
        prop: "agentMemberName",
        width: 90
      }, {
        label: "收货人",
        prop: "recipientName",
        width: 90
      }, {
        label: "联系方式",
        prop: "phoneNumber",
        width: 120
      }, {
        label: "发货人",
        prop: "updateExpressUser",
        width: 90
      }, {
        label: "发货时间",
        prop: "updateExpressTime",
        width: 100
      }, {
        label: "核销人",
        prop: "verifierName",
        width: 90
      }, {
        label: "核销时间",
        prop: "verificateTime",
        width: 100
      }]
    }; // const opHander = operationsHander();
    // opHander.install(OP_KEY.check, (data) => {
    //   // 1017001商品1017002旅行1017003酒店
    //   switch (data.mainBusiType) {
    //     case "1017001":
    //       route.push({
    //         name: "goodsorderdetails",
    //         query: { code: data.orderCode, type: 'show' },
    //       });
    //       break;
    //     case "1017002":
    //       route.push({
    //         name: "travelorderdetails",
    //         query: { code: data.orderCode, type: 'show' },
    //       });
    //       break;
    //     case "1017003":
    //       route.push({
    //         name: "hotelorderdetails",
    //         query: { code: data.orderCode, type: 'show' },
    //       });
    //       break;
    //   }
    // });

    getData();

    function getData() {
      getNum();
      getList();
    }

    function getNum() {
      api.orderNum(route.query().code, val => {
        statusData(val);
      });
    }

    function statusData(val) {
      statusList.forEach((e, i) => {
        e.total = val[i];
      });
    }

    function getList() {
      let routeQuery = route.query();
      api.order({
        status: routeQuery.status,
        memberCode: routeQuery.code,
        page: routeQuery.p,
        size: routeQuery.s
      }, val => {
        total.value = val.total;
        data.value = val.list.map(e => {
          switch (e.mainBusiType) {
            case "1017001":
              e.orderType = "商品";
              break;

            case "1017002":
              e.orderType = "旅游";
              break;

            case "1017003":
              e.orderType = "酒店";
              break;

            case "1017004":
              e.orderType = "综合活动";
              break;
          }

          return e;
        });
      });
    }

    function getExport() {
      let routeQuery = route.query();
      api.orderExport({
        status: routeQuery.status,
        memberCode: routeQuery.code
      }, val => {
        $.download(val.url, "会员列表导出");
      });
    }

    function back() {
      route.go(-1);
    }

    return (_ctx, _cache) => {
      const _component_MemberInfo = _resolveComponent("MemberInfo");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_footer = _resolveComponent("el-footer");

      const _component_el_container = _resolveComponent("el-container");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "base_details_container"
      }, {
        default: _withCtx(() => [_createVNode(BackTitleView, {
          title: "分销员详情"
        }), _createVNode(_component_el_main, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_MemberInfo, {
            type: config.type
          }, null, 8, ["type"])]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_el_button, {
            type: "primary",
            text: "",
            onClick: getExport
          }, {
            default: _withCtx(() => [_createTextVNode("导出")]),
            _: 1
          })]), _createElementVNode("div", _hoisted_8, [_createVNode(StatusBar, {
            data: statusList,
            default: "all"
          }, null, 8, ["data"]), _createVNode(DataCollectTable, {
            data: data.value,
            total: total.value,
            config: tableConfig
          }, null, 8, ["data", "total"])])])])]),
          _: 1
        }), _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: back
          }, {
            default: _withCtx(() => [_createTextVNode("关闭")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }

};